import Occupation from './Occupation'
import Title from './Title'
import Nationality from './Nationality'
import Application from './Application'
import Channel from './Channel'
import EducationLevel from './EducationLevel'
import Branch from './Branch'
import Company from './Company'
import Department from './Department'
import Bank from './Bank'
import PositionType from './PositionType'
import AddressType from './AddressType'
import Gender from './Gender'
import Hobby from './Hobby'
import MaritalStatus from './MaritalStatus'
import ComputerSkill from './ComputerSkill'
import Languages from './Languages'
import MilitaryStatus from './MilitaryStatus'
import EducationGroup from './EducationGroup'
import EducationAcademy from './EducationAcademy'
import IncomeList from './IncomeList'
import ShiftTypeGroup from './ShiftTypeGroup'
import ShiftChangeGroup from './ShiftChangeGroup'
import OtType from './OtType'
import LeaveType from './LeaveType'
import LeaveLevel from './LeaveLevel'
import LeaveQuota from './LeaveQuota'
import welfareQuota from './welfareQuota'
import Hospital from './Hospital'
import TraningTypeINOUT from './TraningTypeINOUT'
import TraningType from './TraningType'
import TraningLocation from './TraningLocation'
import PayrollType from './PayrollType'
import FamilyRelations from './FamilyRelations'
import ManageGroupInsurance from './ManageGroupInsurance'
import ManageInsurance from './ManageInsurance'
import InsuranceCompany from './InsuranceCompany'
import vaccine from './vaccine'
import EmployeeLevel from './EmployeeLevel'
import ManageDocument from './ManageDocument'
import ManageHelp from './ManageHelp'
import Group from './Group'
import Segment from './Segment'

export default {
  FamilyRelations,
  Occupation,
  Title,
  Nationality,
  Application,
  Channel,
  EducationLevel,
  Branch,
  Company,
  Department,
  Bank,
  PositionType,
  AddressType,
  Gender,
  Hobby,
  MaritalStatus,
  ComputerSkill,
  Languages,
  MilitaryStatus,
  EducationGroup,
  EducationAcademy,
  IncomeList,
  ShiftTypeGroup,
  ShiftChangeGroup,
  OtType,
  LeaveType,
  LeaveLevel,
  LeaveQuota,
  welfareQuota,
  Hospital,
  TraningTypeINOUT,
  TraningType,
  TraningLocation,
  PayrollType,
  ManageGroupInsurance,
  ManageInsurance,
  InsuranceCompany,
  vaccine,
  EmployeeLevel,
  ManageDocument,
  ManageHelp,
  Group,
  Segment
}



// WEBPACK FOOTER //
// ./src/components/Master/index.js